<h1 data-test-id="loadingDialogTitle" mat-dialog-title i18n="Load data title text|Title text for data loading@@appdataLoadInDialogPage">Loading data</h1>
<div data-test-id="loadingDialogContent" mat-dialog-content i18n="Have patience label text|Label text for moment patience@@appMomentPatienceInDialogPage">Please wait</div>
<div mat-dialog-actions>
  <div class="loading-spinner">
    <mat-spinner data-test-id="loadingSpinner" diameter="40" strokeWidth="2"></mat-spinner>
  </div>
</div>
